module.exports = new __parcel__URL__("empty-search-error-colour.f0aa9e5e.svg").toString();